module.exports = __webpack_public_path__ + "media/images/ride_requests/login-b0f9af4ab8c2e4823f3425c97d9314c1.svg";